import React from 'react';
import { useTranslation } from 'react-i18next';
import DiscoveryFeatureCard from 'components/DiscoveryFeatureCard';
import useGroupChatBuySideDiscovery from 'router/subrouters/DataRoom/hooks/useGroupChatBuySideDiscovery';
import BannerWrapper from 'components/BannerWrapper';

import './GroupChatBuySideCard.styles.scss';

const GroupChatBuySideCard: React.FC = () => {
  const { showCard, onUnderstood, onOpenGroupChat } =
    useGroupChatBuySideDiscovery();

  const { t } = useTranslation();

  if (!showCard) return null;

  return (
    <BannerWrapper className="messaging__discovery-banner">
      <DiscoveryFeatureCard
        className="group-chat-buy-side-card"
        title={t('groupChatsAvailableTitle')}
        description="groupChatsAvailableBuySideDescription"
        primaryActionLabel={t('openGroupChat')}
        onPrimaryAction={onOpenGroupChat}
        onUnderstood={onUnderstood}
      />
    </BannerWrapper>
  );
};

export default GroupChatBuySideCard;
